/**
 * Extract mentioned user IDs from Draft.js raw content
 * @param {Object} rawContent - The raw content from Draft.js editor (convertToRaw result)
 * @returns {Array} - Array of unique mentioned user SGIDs
 */
export const extractMentionedUsers = (rawContent) => {
  if (!rawContent || !rawContent.entityMap) {
    return [];
  }

  const mentionedUsers = [];
  const { entityMap } = rawContent;

  // Iterate through all entities to find mentions
  Object.keys(entityMap).forEach(key => {
    const entity = entityMap[key];
    
    // Check if the entity is a mention type
    if (entity.type === 'mention' && entity.data && entity.data.mention && entity.data.mention.sgid) {
      mentionedUsers.push(entity.data.mention.sgid);
    }
  });

  // Return unique SGIDs only
  return [...new Set(mentionedUsers)];
};

/**
 * Extract mentioned user IDs from transformed tiptap content
 * @param {Object} tiptapContent - The transformed tiptap content
 * @returns {Array} - Array of unique mentioned user SGIDs
 */
export const extractMentionsFromTiptap = (tiptapContent) => {
  if (!tiptapContent || !tiptapContent.content) {
    return [];
  }

  const mentionedUsers = [];

  const extractFromNode = (node) => {
    if (node.type === 'mention' && node.attrs && node.attrs.sgid) {
      mentionedUsers.push(node.attrs.sgid);
    }

    if (node.content && Array.isArray(node.content)) {
      node.content.forEach(childNode => extractFromNode(childNode));
    }
  };

  tiptapContent.content.forEach(block => extractFromNode(block));

  // Return unique SGIDs only
  return [...new Set(mentionedUsers)];
};
